export default __webpack_public_path__ + "static/media/pdf-footer.be5ec62f.png";